import React, { useState } from "react";
import { Link } from "react-router-dom";
import { beritaData } from "../../data/beritaData";
const Beranda = () => {
  const truncateMultiline = (lines) => {
    return {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: lines,
      overflow: "hidden",
    };
  };

  const [tanggalMasuk, setTanggalMasuk] = useState("");
  const [tanggalPensiun, setTanggalPensiun] = useState("");
  const [estimasiGaji, setEstimasiGaji] = useState(0);
  const [totalManfaat, setTotalManfaat] = useState(0);

  const hitungManfaat = () => {
    if (!tanggalMasuk || !tanggalPensiun || !estimasiGaji) return;

    const masuk = new Date(tanggalMasuk + "T00:00:00");
    const pensiun = new Date(tanggalPensiun + "T00:00:00");

    const tahunMasuk = masuk.getFullYear();
    const bulanMasuk = masuk.getMonth() + 1;
    const tahunPensiun = pensiun.getFullYear();
    const bulanPensiun = pensiun.getMonth() + 1;

    const totalBulanKerja =
      (tahunPensiun - tahunMasuk) * 12 + (bulanPensiun - bulanMasuk);
    const masaKerjaTahun = totalBulanKerja / 12;

    const manfaat = 1.5 * masaKerjaTahun * estimasiGaji;

    setTotalManfaat(Math.round(manfaat));
  };

  const resetForm = () => {
    setTanggalMasuk("");
    setTanggalPensiun("");
    setEstimasiGaji(0);
    setTotalManfaat(0);
  };

  const formatRupiah = (number) => {
    if (!number) return "";
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  const board = [
    {
      name: "Rita Inggriani",
      position: "Direktur Utama",
      image: "/images/asset/rita.svg",
    },
    {
      name: "I Made Surya W",
      position: "Wakil Direktur Utama",
      image: "/images/asset/surya.svg",
    },
    {
      name: "Mintarjo Darmali",
      position: "Anggota",
      image: "/images/asset/mintarjo.svg",
    },
    {
      name: "Johanes Pandoyopranoto",
      position: "Anggota",
      image: "/images/asset/johanes.svg",
    },
  ];

  const reports = [
    {
      category: "Peraturan",
      title: "POJK 35 Tahun 2024",
      file: "/pdfs/POJK 35 Tahun 2024 Perizinan dan Kelembagaan Dana Pensiun.pdf",
    },
    {
      category: "Laporan",
      title: "Laporan Valuasi Aktuaris DPTA 31 Desember 2024",
      file: "/pdfs/Laporan Valuasi Aktuaris DPTA 31 desember 2024_web.pdf",
    },
    {
      category: "Peraturan",
      title: "POJK 27 Tahun 2023",
      file: "/pdfs/POJK 27 Tahun 2023 Penyelenggaraan Usaha Dana Pensiun.pdf",
    },
    {
      category: "Laporan",
      title: "Laporan Pengawasan Kinerja Investasi 2024",
      file: "/pdfs/Laporan Pengawasan Kinerja Investasi 2024.web.pdf",
    },

    {
      category: "Laporan",
      title: "PDP 2019",
      file: "/pdfs/PDP 2019_rotated.pdf",
    },
    {
      category: "Peraturan",
      title: "UU No. 11 Tahun 1992",
      file: "/pdfs/UU Nomor 11 Tahun 1992.pdf",
    },
  ];

  const faqs = [
    {
      question: "Dari sudut pendiri, ada berapa jenis Dana Pensiun?",
      answer:
        "Secara umum ada 2 jenis Dana Pensiun: Dana Pensiun Pemberi Kerja, yaitu Dana Pensiun yang didirikan oleh Perusahaan, baik swasta maupun BUMN, dan pesertanya adalah karyawan perusahaan tersebut. Ada pula Dana Pensiun Lembaga Keuangan, yaitu Dana Pensiun yang anggotanya umum, masyarakat umum boleh menjadi anggota.",
    },
    {
      question: "Apa bedanya Dana Pensiun Manfaat Pasti dan Iuran Pasti?",
      answer:
        "Dana Pensiun Manfaat Pasti, seperti Dana Pensiun Toyota Astra adalah Dana Pensiun yang memberikan manfaat dalam jumlah yang pasti. Manfaat pension yang didapat peserta sudah pasti jumlahnya, yaitu berdasarkan masa kerja dan besarnya gaji. Sedangkan Dana Pensiun Iuran pasti, yang ditentukan adalah besarnya iuran, biasanya pesentase dari gaji. Tidak ada rumusan pasti berapa besarnya manfaat pension yang didapat, tergantung dari hasil pengembangannya. ",
    },
    {
      question:
        "Di Dana Pensiun Toyota Astra, berapa besarnya iuran peserta dan iuran perusahaan",
      answer:
        "Di Dana Pensiun Toyota Astra, tidak ada iuran peserta. 100% iuran ditanggung perusahaan, dan besarnya berdasarkan perhitungan Aktuaria yang bisa berubah-ubah tergantung kondisi keuangan Dana Pensiun.",
    },
    {
      question: "Kapan manfaat pension dapat dibayarkan?",
      answer:
        "Manfaat pension hanya dapat dibayarkan pada saat karyawan berhenti bekerja. Karyawan berhenti bekerja bisa karena mencapai usia pension normal (55 tahun), meninggal dunia, atau mengundurkan diri. Manfaat pension tidak dapat dibayarkan selama peserta mesih berstatus sebagai karyawan Pendiri atau Mitra Pendiri.",
    },
    {
      question:
        "Apakah manfaat pension yang dibayarkan terkena pajak dan berapa besarnya?",
      answer:
        "Manfaat pensiun sebesar Rp. 50 juta pertama tidak terkena pajak. Selebihnya terkena pajak final sebesar 5%.",
    },
    {
      question:
        "Kapan manfaat pensiun bisa dibayarkan secara sekaligus (lump sum) dan kapan harus dibelikan Anuitas?",
      answer:
        "Berdasarkan Peraturan Otoritas Jasa Keuangan nomor 27 tahun 2023, pembayaran manfaat pensiun harus dibayarkan secara bulanan dengan dibelikan produk anuitas dari Perusahaan Asuransi Jiwa apabila besarnya manfaat pensiun gross sebesar Rp. 625 juta atau lebih. Khusus untuk peserta yang mulai bekerja sebelum tanggal 20 April 1992 (saat diberlakukannya Undang undang Dana Pensiun no 11 tahun 1992), kewajiban untuk membeli produk anuitas ini tidak berlaku.",
    },
  ];

  return (
    <>
      <header className="relative w-full  h-screen overflow-hidden bg-white">
        <img
          src="/images/asset/new-hero-dapen.svg"
          alt="Hero"
          className="
        absolute inset-0 
        w-full h-full 
        object-cover        
        pointer-events-none select-none
      "
          style={{
            objectPosition: "center",
          }}
        />

        <div className="relative z-10 flex flex-col items-center justify-between h-full pt-18 pb-10 px-4 text-white text-center">
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="mb-6 max-w-2xl text-center">
              <h1 className="flex flex-wrap items-center justify-center gap-2 text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug">
                <span className="bg-white text-red-600 px-3 py-1 rounded font-pontano">
                  Dana Pensiun Toyota Astra
                </span>
              </h1>
              <p className="mt-3 text-sm sm:text-base md:text-lg drop-shadow-sm font-inter bg-white text-red-600">
                Untuk kehidupan karyawan setelah masa purna bakti.
              </p>
            </div>
          </div>
        </div>
      </header>

      <section className="relative z-20 bg-[#F1F1F1] rounded-t-[40px] -mt-12 sm:-mt-16 px-4 sm:px-8 lg:px-24 py-8 sm:py-12">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 flex justify-center">
            <img
              src="/images/asset/rupiah.svg"
              alt="rupiah-icon"
              className="w-34 h-34 lg:w-42 lg:h-42"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl sm:text-3xl font-semibold mb-4 font-pontano">
              Dana Pensiun Toyota Astra
            </h2>
            <p className="text-gray-600 text-sm sm:text-base font-inter">
              Dana Pensiun Toyota Astra adalah Dana Pensiun Pemberi Kerja,
              dengan program manfaat pasti. Didirikan pada tanggal 16 April 1993
              sebagai penerapan dari Undang Undang Dana Pensiun nomor 11 tahun
              1992. Sebagai pendiri adalah PT. Toyota Motor Manufacturing
              Indoneia, sedangkan sebagai Mitra Pendiri adalah PT. Toyota Astra
              Motor. Pesertanya adalah semua karyawan PT. Toyota Motor
              Manufacturing Indonesia dan PT. Toyota Astra Motor yang diangkat
              sampai dengan tanggal 31 Desember 2011.
            </p>
          </div>
        </div>

        <div className="bg-white shadow rounded-2xl p-6 mt-12">
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="mt-1 w-12 h-12 min-w-[48px]">
                <img
                  src="/images/asset/visi-misi.svg"
                  alt="Visi Icon"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="font-bold text-lg font-pontano">
                  Visi Dana Pensiun Toyota Astra
                </h3>
                <p className="text-sm text-gray-600 font-inter">
                  Menjadi Dana Pensiun yang sehat untuk menunjang kepentingan
                  Pendiri dan Mitra Pendiri serta Kesinambungan Penghasilan
                  Peserta.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="mt-1 w-12 h-12 min-w-[48px]">
                <img
                  src="/images/asset/visi-misi.svg"
                  alt="Misi Icon"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="font-bold text-lg font-pontano">
                  Misi Dana Pensiun Toyota Astra
                </h3>
                <p className="text-sm text-gray-600 font-inter">
                  . Mengelola Aset Dana Pensiun sesuai dengan arahan investasi
                  <br />. Menyelenggarakan dana Pensiun yang transparan,
                  akuntabel, dan bertanggung jawab untuk semua stakeholder{" "}
                  <br />. Memberikan pelayanan terbaik kepada Pendiri, Mitra
                  Pendiri, dan Peserta.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <h2 className="text-2xl font-semibold mb-6 font-pontano">
            Susunan Pengurus Dana Pensiun Toyota Astra
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {board.map((member, idx) => (
              <div key={idx} className="overflow-hidden text-center">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-auto"
                />
                <div className="p-4">
                  <h3 className="font-semibold text-base text-gray-900 font-pontano">
                    {member.name}
                  </h3>
                  <p className="text-sm text-gray-600 font-inter">
                    {member.position}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/tentang-kami"
            className="text-[#EB0A1E] text-sm font-bold inline-flex items-center gap-1 hover:underline"
          >
            Selengkapnya{" "}
            <img
              src="/images/asset/arrow.svg"
              alt="arrow"
              className="w-4 h-4 object-contain"
            />
          </Link>
        </div>
      </section>

      <section className="bg-white px-4 sm:px-8 lg:px-24 py-12">
        <div className="text-center mt-12">
          <h2 className="text-2xl font-semibold mb-6 font-pontano">
            Laporan Dana Pensiun Toyota Astra
          </h2>

          <div className="mb-10 text-left">
            <div className="grid grid-cols-1 gap-4 max-w-5xl mx-auto place-items-center">
              {reports
                .filter((r) => r.category.toLowerCase().includes("laporan"))
                .map((report, idx) => (
                  <div
                    key={idx}
                    className="bg-white p-4 rounded-xl shadow flex items-center justify-between gap-4 w-full max-w-lg mx-auto"
                  >
                    <div className="flex-1 min-w-0">
                      <span className="text-xs font-medium text-red-500 font-inter">
                        {report.category}
                      </span>
                      <span className="block text-sm font-semibold text-gray-800 font-pontano truncate">
                        {report.title}
                      </span>
                    </div>

                    <a
                      href={report.file}
                      download
                      className="shrink-0 inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition"
                    >
                      Download
                      <img
                        src="/images/asset/download.svg"
                        alt="Download"
                        className="w-4 h-4"
                      />
                    </a>
                  </div>
                ))}
            </div>
          </div>

          <div className="text-center">
            <h3 className="text-2xl font-semibold mb-6 font-pontano">
              Peraturan Dana Pensiun Toyota Astra
            </h3>
            <div className="grid grid-cols-1 gap-4 max-w-5xl mx-auto place-items-center">
              {reports
                .filter((r) => r.category.toLowerCase().includes("peraturan"))
                .map((report, idx) => (
                  <div
                    key={idx}
                    className="bg-white p-4 rounded-xl shadow flex items-center justify-between gap-4 w-full max-w-lg"
                  >
                    <div className="flex flex-col justify-center text-left">
                      <span className="text-xs font-medium text-red-500 font-inter">
                        {report.category}
                      </span>
                      <span className="text-sm font-semibold text-gray-800 font-pontano">
                        {report.title}
                      </span>
                    </div>
                    <div className="self-center">
                      <a
                        href={report.file}
                        download
                        className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition self-start"
                      >
                        Download
                        <img
                          src="/images/asset/download.svg"
                          alt="Download"
                          className="w-4 h-4"
                        />
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#f1f1f1] px-4 sm:px-8 lg:px-24 py-12">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-6 font-pontano">Berita</h2>
        </div>
        <div className="text-start">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {beritaData.map((item) => (
              <div
                key={item.id}
                className="hover:shadow-md transition-all duration-300 flex flex-col"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[220px] md:h-[260px] lg:h-[280px] xl:h-[300px] object-cover"
                />
                <div className="p-4 flex flex-col flex-1">
                  <h3
                    className="text-sm font-bold text-gray-900 mb-2 leading-snug"
                    style={truncateMultiline(2)}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="text-sm text-gray-600 mb-4"
                    style={truncateMultiline(3)}
                  >
                    {item.summary}
                  </p>
                  <div className="mt-auto flex justify-center">
                    <Link
                      to={`/berita/${item.id}`}
                      className="text-[#EB0A1E] text-sm font-bold inline-flex items-center gap-1 hover:underline"
                    >
                      Selengkapnya{" "}
                      <img
                        src="/images/asset/arrow.svg"
                        alt="arrow"
                        className="w-4 h-4 object-contain"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F1F1F1] px-4 sm:px-8 lg:px-24 py-12">
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-semibold mb-6 font-pontano">
            Simulasi Estimasi Manfaat Pensiun Normal (55 Tahun)
          </h2>
          <div className="bg-white rounded-xl p-6 max-w-xl mx-auto shadow-md text-left">
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium font-inter">
                  Tanggal Masuk Mulai Bekerja{" "}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className="input input-bordered w-full mt-1"
                  value={tanggalMasuk}
                  onChange={(e) => setTanggalMasuk(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium font-inter">
                  Tanggal Pensiun Normal <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className="input input-bordered w-full mt-1"
                  value={tanggalPensiun}
                  onChange={(e) => setTanggalPensiun(e.target.value)}
                />
              </div>
              {/* <div>
                <label className="block text-sm font-medium font-inter">
                  Estimasi Gaji Terakhir
                </label>
                <input
                  type="text"
                  placeholder="Rp. 0,000,000"
                  className="input input-bordered w-full mt-1"
                  value={estimasiGaji}
                  onChange={(e) => setEstimasiGaji(Number(e.target.value))}
                />
              </div> */}
              <div>
                <label className="block text-sm font-medium font-inter">
                  Estimasi Gaji Terakhir
                </label>
                <input
                  type="text"
                  placeholder="Rp. 0,000,000"
                  className="input input-bordered w-full mt-1"
                  value={formatRupiah(estimasiGaji)}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\./g, "");
                    const numeric = parseInt(raw, 10);
                    setEstimasiGaji(isNaN(numeric) ? 0 : numeric);
                  }}
                />
              </div>
              <div className="flex justify-between">
                <button
                  type="button"
                  className="btn btn-ghost text-red-500 font-inter"
                  onClick={resetForm}
                >
                  Reset
                </button>
                <button
                  type="button"
                  className="btn bg-[#EB0A1E] text-white font-inter"
                  onClick={hitungManfaat}
                >
                  Hitung
                </button>
              </div>
            </form>
            <div className="mt-6 rounded-b-xl overflow-hidden">
              <div
                className="bg-cover bg-center text-white text-center py-6"
                style={{ backgroundImage: "url(/images/asset/simulasi.svg)" }}
              >
                <p className="text-sm sm:text-base font-inter">
                  Nilai Manfaat Pensiun pada saat Pensiun Normal
                </p>
                Rp.{" "}
                {totalManfaat.toLocaleString("id-ID", {
                  minimumFractionDigits: 0,
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F1F1F1] px-4 sm:px-8 lg:px-24 py-12">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-8 font-pontano">
            Frequently Asked Question
          </h2>
          <div className="max-w-6xl mx-auto space-y-3">
            {faqs.map((item, index) => (
              <div
                className="collapse collapse-arrow bg-white rounded-xl shadow"
                key={index}
              >
                <input type="checkbox" />
                <div className="collapse-title text-sm font-semibold text-left text-redPrimary font-pontano">
                  <div className="text-redPrimary text-xs font-inter">
                    Question
                  </div>
                  <span className="text-gray-800">{item.question}</span>
                </div>
                <div className="collapse-content text-sm text-gray-800 pt-0 text-start font-inter">
                  {item.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Beranda;
